import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BaseComponent } from '../base.component';

export interface ModQualityConfig {
  minPerfectPrefixes?: number;
  minPerfectSuffixes?: number;
  minGreatPrefixes?: number;
  minGreatSuffixes?: number;
  minPerfectMods?: number;
  minGreatMods?: number;
  minGoodMods?: number;
  maxBadMods?: number;
}

@Component({
  selector: 'app-mod-quality-filters',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './mod-quality-filters.component.html',
  styleUrl: './mod-quality-filters.component.scss'
})
export class ModQualityFiltersComponent extends BaseComponent {
  @Input() standalone: boolean = false;
  @Input({ required: true }) config!: ModQualityConfig;
  @Output() configChange = new EventEmitter<void>();

  updateFilter() {
    this.configChange.emit();
  }
}
